import { Component, Input, OnInit } from '@angular/core';
import { Item, SectionMenu } from '../../models/menu.model';

@Component({
    selector: 'app-item-gallery',
    templateUrl: './item-gallery.component.html',
    styleUrls: ['./item-gallery.component.scss'],
    standalone: false
})
export class ItemGalleryComponent implements OnInit {
  /**
   * Listado de imagenes
   */
  @Input() section: SectionMenu = {} as SectionMenu;
  constructor() { }

  ngOnInit(): void {
  }


  /**
   * Si el item tiene configurado una URL
   * al darle click navegara a dicha ruta
   *
   * @param item info de la imagen
   */
  goLink(item: Item): void {
    if (item.url) {
      window.open(item.url, '_blank');
    }
  }

}
